/**
 * Runtime configuration with fallback to build-time env vars.
 *
 * In production (Docker), envsubst replaces ${VAR} placeholders in /config.js
 * at container startup, making window.runConfig available before React loads.
 *
 * In development, window.runConfig values start with "${" (unprocessed),
 * so we fall back to import.meta.env (Vite dev server).
 */

declare global {
  interface Window {
    runConfig?: {
      apiUrl: string;
      baseName: string;
      stripePublishableKey: string;
      appVersion: string;
    };
  }
}

const runtimeConfig = window.runConfig;

const localConfig = {
  apiUrl: import.meta.env.VITE_APP_API_URL || 'http://localhost:5555/api/v1',
  baseName: import.meta.env.VITE_APP_BASE_NAME || '/',
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
  appVersion: import.meta.env.VITE_APP_VERSION || 'v5.0.0',
};

const isRuntimeConfigAvailable = runtimeConfig && !runtimeConfig.apiUrl.startsWith('${');

// Debug logging — remove after confirming runtime config works
console.log('[runtime-config] window.runConfig:', JSON.stringify(runtimeConfig));
console.log('[runtime-config] isRuntimeConfigAvailable:', isRuntimeConfigAvailable);
console.log('[runtime-config] localConfig:', JSON.stringify(localConfig));

const activeConfig = isRuntimeConfigAvailable ? runtimeConfig : localConfig;

console.log('[runtime-config] activeConfig (using ' + (isRuntimeConfigAvailable ? 'RUNTIME' : 'LOCAL') + '):', JSON.stringify(activeConfig));

export const RUNTIME_CONFIG = {
  apiUrl: activeConfig.apiUrl,
  baseName: activeConfig.baseName,
  stripePublishableKey: activeConfig.stripePublishableKey,
  appVersion: activeConfig.appVersion,
};

export const API_URL = RUNTIME_CONFIG.apiUrl;
